import BusinessTerms from '../business-terms';

export default BusinessTerms;
